import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import useSkeletonTheme from '../../hooks/useSkeletonTheme';

const MediaItemSkeleton = () => {
    const { base } = useSkeletonTheme();
    return (
        <SkeletonTheme color={base.color} highlightColor={base.highlightColor}>
            <div className="media-item card">
                <Skeleton className="col-12" height={180} />
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <Skeleton count={3} />
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
};

export default MediaItemSkeleton;
